import { Directive, OnInit, ElementRef, OnDestroy, Input, OnChanges, SimpleChanges, HostListener } from '@angular/core';
import { SharedService } from '../shared/services/shared.service';
import { Subscription } from 'rxjs';

enum AppColorTargets {
    BACKGROUND = 'background',
    COLOR = 'color',
    BORDER = 'border',
    BACKGROUND_AND_BORDER = 'backgroundAndBorder',
    BACKGROUND_WITH_OPACITY_AND_BORDER = 'backgroundWithOpacityAndBorder',
    BORDER_WITH_CHECKBOX_INSIDE = 'borderWithCheckboxInside',
    CUSTOM_BACKGROUND_COLOR = 'customBackgroundColor'
}

@Directive({
    selector: '[appColor]'
})

export class AppColor implements OnDestroy, OnChanges {

    @HostListener('focus') onFocus() {
        this.transformColor();
    }

    @HostListener('mouseover') onMouseOver() {
        this.transformColor();
    }

    @HostListener('blur') onMouseLeave() {
        this.transformColor();
    }

    @Input() activeClass: boolean = null;
    @Input() appColor: AppColorTargets = null;

    appColorSub: Subscription;
    color: string;
    checkImage = require('../../assets/images/check-box.svg');
    backgroundImage = require('../../assets/images/users-bg.png');
    buttonColors = {
        "#2A8BDB": "#1463AD",
        "#1C6FC1": "#075099",
        "#246AA1": "#0F497D",
        "#652995": "#4A1D70",
        "#377414": "#2A5C01",
        "#5A5A5A": "#0070CC",
    }

    constructor(
        private sharedService: SharedService,
        private elRef: ElementRef,
    ) {
        this.appColorSub = this.sharedService.appColorSub.subscribe(color => {
            this.color = color;
            this.transformColor();
        })
    }

    ngOnChanges(changes: SimpleChanges) {
        this.transformColor();
    }

    transformColor = () => {
        try {
            if (!this.color) {
                return;
            }
            const nativeElement = this.elRef.nativeElement;
            const tagName = nativeElement.tagName;
            switch (tagName) {
                case 'MDL-BUTTON': {
                    this.setButtonColor(nativeElement);
                    break;
                }
                case 'DIV': {
                    this.setDivStyles(nativeElement);
                    break;
                }
                case 'MDL-TEXTFIELD': {
                    this.setInputBorderAndColor(nativeElement);
                    break;
                }
                case 'MDL-SELECT': {
                    this.setSelectBorderAndColor(nativeElement);
                    this.setSelectedDropdownItemColor(nativeElement);
                    break;
                }
                case 'MDL-RADIO': {
                    this.setMDLRadioStyle(nativeElement);
                    break;
                }
                case 'SPAN': {
                    this.setColor(nativeElement);
                }
                case 'MDL-CHECKBOX': {
                    // this.setCheckboxStyles(nativeElement);
                    break;
                }
            }
        } catch (error) {

        }
    }

    setBackgroundColor = (nativeElement: any, with_opacity?: boolean) => {
        if (this.appColor === AppColorTargets.COLOR) {
            nativeElement.style.color = `${this.color}`;
            nativeElement.style.background = '';
            return;
        }
        if (this.activeClass === null) {
            nativeElement.style.background = this.getBgColor(this.color, with_opacity);
        } else {
            if (this.activeClass) {
                nativeElement.style.background = this.getBgColor(this.color, with_opacity);
            } else {
                nativeElement.style.background = '';
                nativeElement.style.color = '';
            }
        }
    }

    getBgColor(color: string, with_opacity?: boolean) {
        if (with_opacity) {
            return this.hexToRgbA(color, '0.06');
        } else {
            return color;
        }
    }

    hexToRgbA(hex: string, opacity: string){
        var c: any;
        if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
            c= hex.substring(1).split('');
            if(c.length== 3){
                c= [c[0], c[0], c[1], c[1], c[2], c[2]];
            }
            c= '0x'+c.join('');
            return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+','+opacity+')';
        }
        throw new Error('Bad Hex');
    }

    setCustomBackgroundColor = (nativeElement: any) => {
        nativeElement.style.backgroundColor = `${this.color}`;
    }

    setButtonColor = (nativeElement: any) => {
        if (this.appColor === AppColorTargets.COLOR) {
            nativeElement.style.color = `${this.buttonColors[this.color]}`;
            nativeElement.style.background = '';
            return;
        }
        if (this.activeClass === null) {
            nativeElement.style.background = this.buttonColors[this.color];
            nativeElement.style.color = 'white';
        } else {
            if (this.activeClass) {
                nativeElement.style.background = this.buttonColors[this.color];
                nativeElement.style.color = 'white';
            } else {
                nativeElement.style.background = '';
                nativeElement.style.color = '';
            }
        }

    }

    setInputBorderAndColor = (nativeElement: any) => {
        setTimeout(() => {
            const input = nativeElement.querySelector('.mdl-textfield__input');
            const label = nativeElement.querySelector('label');
            if (
                [...nativeElement.classList].indexOf('is-focused') > -1 ||
                [...nativeElement.classList].indexOf('is-dirty') > -1
            ) {
                input ? input.style.border = `1px solid ${this.color}` : '';
                label ? label.style.color = this.color : '';
            } else {
                input ? input.style.border = '' : '';
                label ? label.style.color = '' : '';
            }
        }, 100);
    }

    setSelectBorderAndColor = (nativeElement: any) => {
        setTimeout(() => {
            if (
                [...nativeElement.querySelector('div').classList].indexOf('is-focused') > -1 ||
                [...nativeElement.querySelector('div').classList].indexOf('is-dirty') > -1
            ) {
                nativeElement.querySelector('input').style.borderColor = this.color;
                nativeElement.querySelector('label').style.color = this.color;
            } else {
                nativeElement.querySelector('input').style.borderColor = '';
                nativeElement.querySelector('label').style.color = '';
            }
        });
    }

    setColor = (nativeElement: any) => {
        nativeElement.style.color = this.color;
    }

    setSelectedDropdownItemColor = (nativeElement: any) => {
        setTimeout(() => {
            let popover = nativeElement.querySelector('mdl-popover');
            if ([...popover.classList].indexOf('is-visible') > -1) {
                const input = nativeElement.querySelector('.mdl-list__item.is-active');
                nativeElement.querySelectorAll('.mdl-list__item').forEach((element: any) => {
                    element ? element.style.color = '' : '';
                });
                input ? input.style.color = this.color : '';
            }
        });
    }

    setMDLRadioStyle = (nativeElement: any) => {
        setTimeout(() => {
            nativeElement.querySelector('.mdl-radio__inner-circle').style.background = `${this.color} url(${this.checkImage}) no-repeat`;
            nativeElement.querySelector('.mdl-radio__inner-circle').style.backgroundSize = "15px 15px";
            nativeElement.querySelector('.mdl-radio__inner-circle').style.backgroundPosition = "center center";
            nativeElement.querySelector('.mdl-radio__inner-circle').style.borderRadius = "50%";
            nativeElement.querySelector('.mdl-radio__inner-circle').style.top = "4px";
            nativeElement.querySelector('.mdl-radio__inner-circle').style.left = "0px";
        }, 100);
    }

    setBorderColorAndCheckboxInside = (nativeElement: any) => {
        const hasCheckBoxInside = nativeElement.querySelector('mdl-checkbox');
        if (this.activeClass === null) {
            nativeElement.style.background = this.color;
        } else {
            if (this.activeClass) {
                nativeElement.style.borderColor = this.color;
                hasCheckBoxInside ? nativeElement.querySelector('.mdl-checkbox__tick-outline').style.background = this.color : '';
            } else {
                nativeElement.style.borderColor = '';
                hasCheckBoxInside ? nativeElement.querySelector('.mdl-checkbox__tick-outline').style.background = '' : '';
            }
        }
    }

    setBorderColor = (nativeElement: any) => {
        if (this.activeClass === null) {
            nativeElement.style.background = this.color;
        } else {
            if (this.activeClass) {
                nativeElement.style.borderColor = this.color;
            } else {
                nativeElement.style.borderColor = '';
            }
        }
    }

    setDivStyles = (nativeElement: any) => {
        switch (this.appColor) {
            case AppColorTargets.BACKGROUND: {
                this.setBackgroundColor(nativeElement);
                break;
            }
            case AppColorTargets.CUSTOM_BACKGROUND_COLOR: {
                this.setCustomBackgroundColor(nativeElement);
                break;
            }
            case AppColorTargets.BORDER: {
                this.setBorderColor(nativeElement);
                break;
            }
            case AppColorTargets.BACKGROUND_AND_BORDER: {
                this.setBackgroundColor(nativeElement);
                this.setBorderColor(nativeElement);
                break;
            }
            case AppColorTargets.BACKGROUND_WITH_OPACITY_AND_BORDER: {
                this.setBackgroundColor(nativeElement, true);
                this.setBorderColor(nativeElement);
                break;
            }
            case AppColorTargets.BORDER_WITH_CHECKBOX_INSIDE: {
                this.setBorderColorAndCheckboxInside(nativeElement);
            }
        }
    }

    setCheckboxStyles = (nativeElement: any) => {
        setTimeout(() => {
            if ([...nativeElement.classList].indexOf('is-checked') > -1) {
                nativeElement.querySelector('.mdl-checkbox__tick-outline').style.background = `${this.color}`;
            } else {
                nativeElement.querySelector('.mdl-checkbox__tick-outline').style.background = '';
            }
        }, 100);
    }

    ngOnDestroy() {
        if (this.appColorSub) {
            this.appColorSub.unsubscribe();
        }
    }

}
